import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import * as styles from './Arrow.css';
import { getLeftArrow, getRightArrow } from './ArrowIcon';
import { EArrowsSize } from '../../../../types';
import { mergeStyles } from '@cian/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var Arrow = function Arrow(props) {
  var width = props.width,
    direction = props.direction,
    show = props.show,
    size = props.size,
    clickHandler = props.clickHandler;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['click-area'], !show && styles['click-area-hidden'], direction < 0 && styles['click-area-left'], size === EArrowsSize.LARGE && styles['click-area-large'])), {}, {
    style: {
      width: width
    },
    onClick: function onClick() {
      return clickHandler && clickHandler(direction);
    },
    "data-testid": "Arrow",
    children: /*#__PURE__*/_jsx("div", {
      className: styles['background'],
      children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['icon-container'], direction > 0 && styles['icon-container-right'])), {}, {
        children: /*#__PURE__*/_jsx("div", {
          className: styles['icon'],
          children: direction < 0 ? getLeftArrow(size) : getRightArrow(size)
        })
      }))
    })
  }));
};